import styled from 'styled-components'
import colorsOptions from '../../fundamentals/colors-styles/constants.js'

export const TableWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  color: ${colorsOptions.greys['grey-90']};
`

export const TableStyled = styled.table`
  background-color: ${colorsOptions.greys.white};
  border: 1px solid ${colorsOptions.greys['grey-20']};
  border-radius: 8px;
  border-collapse: separate;
  border-spacing: 0;
`

export const TableDndFrame = styled.div`
  position: relative;
  width: 100%;
  border-radius: 8px;

  ${({ $canDrop, $isDroppable, $isOver }) =>
    $isDroppable &&
    $canDrop &&
    $isOver &&
    `
      &::after {
        content: '';
        position: absolute;
        inset: 0;
        pointer-events: none;
        border: 2px dashed ${colorsOptions.docuToolsOrange['dt-40']};
        border-radius: 8px;
        box-shadow: inset 0 0 0 4px ${colorsOptions.docuToolsOrange['dt-10']};
        z-index: 2;
      }
    `}
`

export const HeaderTr = styled.tr`
  width: fit-content;
`

export const BodyTr = styled.tr`
  width: fit-content;

  &:last-child {
    td {
      &:first-child {
        border-bottom-left-radius: 16px;
      }

      &:last-child {
        border-bottom-right-radius: 16px;
      }
    }
  }

  background-color: ${colorsOptions.greys.white};

  &:hover {
    background-color: ${colorsOptions.greys['grey-05']};
  }
  &[data-selected='true'] {
    background-color: ${colorsOptions.greys['grey-20']};
  }
  &:disabled {
    background-color: ${colorsOptions.greys['grey-40']};
  }
`

export const BodyTrDnD = styled(BodyTr)`
  position: relative;
  transform: ${({ transform }) => transform};
  transition: ${({ transition }) => transition};

  /* Draggable styles */
  opacity: ${({ isDragging }) => (isDragging ? 0.9 : 1)};
  z-index: ${({ isDragging }) => (isDragging ? 2 : 'auto')};
  background-color: ${({ isDragging }) =>
    isDragging
      ? colorsOptions.docuToolsOrange['dt-10']
      : colorsOptions.greys.white};

  &:hover,
  &:focus-within {
    z-index: 1;
  }

  /* Droppable styles */
  ${({ canDrop = true, isDroppable, isOver }) =>
    isDroppable &&
    isOver &&
    canDrop &&
    `
      border-radius: 4px;
      outline: 2px dashed ${colorsOptions.docuToolsOrange['dt-40']};
      outline-offset: -2px;
      background-color: ${colorsOptions.docuToolsOrange['dt-20']};
    `}
`

export const BodyTd = styled.td`
  border-top: 1px solid ${colorsOptions.greys['grey-20']};
`

// Expandable Row Chevron Container
export const RowLeadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
`

export const ToolbarPagesContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`
